// mutations
const mutations = {
  UPDATE_FORM_COMPLETED(state, formCompleted) {
    state.formCompleted = formCompleted;
  },
  UPDATE_FIRST_NAME(state, firstname) {
    state.firstname = firstname
  },
  UPDATE_IDENTITY_NUMBER(state, identityNo) {
    state.identityNo = identityNo
  },
  UPDATE_PASSPORT_NUMBER(state, passportNo) {
    state.passportNo = passportNo
  },
  UPDATE_IDENTITY_NUMBER_OTHER(state, identityNoOther) {
    state.identityNoOther = identityNoOther
  },
  UPDATE_SEX(state, sexId) {
    state.sexId = sexId
  },
  UPDATE_MARITAL_STATUS(state, maritalStatus) {
    state.maritalStatus = maritalStatus
  },
  UPDATE_BIRTH_DT(state, birthDt) {
    state.birthDt = birthDt
  },
  UPDATE_OTHER_BIRTH_DT(state, otherBirthDt) {
    state.otherBirthDt = otherBirthDt
  },
  UPDATE_NATIONALITY(state, nationalityId) {
    state.nationalityId = nationalityId
  },
  UPDATE_RELIGION(state, religionId) {
    state.religionId = religionId
  },
  UPDATE_BIRTH_COUNTRY(state, birthCountryId) {
    state.birthCountryId = birthCountryId
  },
  UPDATE_BIRTH_STATE(state, birthStateId) {
    state.birthStateId = birthStateId
  },
  UPDATE_OTHER_BIRTH_STATE_NAME(state, otherBirthStateName) {
    state.otherBirthStateName = otherBirthStateName
  },
  UPDATE_RACE(state, raceId) {
    state.raceId = raceId
  },
  UPDATE_ETHNIC(state, ethnicId) {
    state.ethnicId = ethnicId
  },
  UPDATE_ETHNIC_FREETEXT(state, ethnicFreeText) {
    state.ethnicFreeText = ethnicFreeText
  },
  UPDATE_CHRONIC_DISEASE(state, isChronicDisease) {
    state.isChronicDisease = isChronicDisease
  },
  UPDATE_CHRONIC_DISEASE_DETAILS(state, chronicDiseaseDetails) {
    state.chronicDiseaseDetails = chronicDiseaseDetails
  },
  UPDATE_DISABILITY(state, isDisable) {
    state.isDisable = isDisable
  },
  UPDATE_LIVING(state, isLiving) {
    state.isLiving = isLiving
  },
  UPDATE_PERMANENT_ADDRESS(state, permanentAddressId) {
    state.permanentAddressId = permanentAddressId
  },
  UPDATE_PERMANENT_ADDRESS1(state, permanentAddress1) {
    state.permanentAddress1 = permanentAddress1
  },
  UPDATE_PERMANENT_ADDRESS2(state, permanentAddress2) {
    state.permanentAddress2 = permanentAddress2
  },
  UPDATE_PERMANENT_ADDRESS3(state, permanentAddress3) {
    state.permanentAddress3 = permanentAddress3
  },
  UPDATE_PERMANENT_POSTCODE(state, permanentPostcode) {
    state.permanentPostcode = permanentPostcode
  },
  UPDATE_PERMANENT_CITY_ID(state, permanentCityId) {
    state.permanentCityId = permanentCityId
  },
  UPDATE_PERMANENT_STATE_ID(state, permanentStateId) {
    state.permanentStateId = permanentStateId
  },
  UPDATE_PERMANENT_COUNTRY_ID(state, permanentCountryId) {
    state.permanentCountryId = permanentCountryId
  },
  UPDATE_PERMANENT_CITY_NAME(state, permanentCityName) {
    state.permanentCityName = permanentCityName
  },
  UPDATE_PERMANENT_STATE_NAME(state, permanentStateName) {
    state.permanentStateName = permanentStateName
  },
  UPDATE_PERMANENT_OTHER_STATE_NAME(state, permanentOtherStateName) {
    state.permanentOtherStateName = permanentOtherStateName
  },
  UPDATE_PERMANENT_COUNTRY_NAME(state, permanentCountryName) {
    state.permanentCountryName = permanentCountryName
  },
  UPDATE_MAIL_ADDRESS(state, mailAddressId) {
    state.mailAddressId = mailAddressId
  },
  UPDATE_MAIL_ADDRESS1(state, mailAddress1) {
    state.mailAddress1 = mailAddress1
  },
  UPDATE_MAIL_ADDRESS2(state, mailAddress2) {
    state.mailAddress2 = mailAddress2
  },
  UPDATE_MAIL_ADDRESS3(state, mailAddress3) {
    state.mailAddress3 = mailAddress3
  },
  UPDATE_MAIL_POSTCODE(state, mailPostcode) {
    state.mailPostcode = mailPostcode
  },
  UPDATE_MAIL_CITY_ID(state, mailCityId) {
    state.mailCityId = mailCityId
  },
  UPDATE_MAIL_STATE_ID(state, mailStateId) {
    state.mailStateId = mailStateId
  },
  UPDATE_MAIL_COUNTRY_ID(state, mailCountryId) {
    state.mailCountryId = mailCountryId
  },
  UPDATE_MAIL_CITY_NAME(state, mailCityName) {
    state.mailCityName = mailCityName
  },
  UPDATE_MAIL_STATE_NAME(state, mailStateName) {
    state.mailStateName = mailStateName
  },
  UPDATE_MAIL_OTHER_STATE_NAME(state, mailOtherStateName) {
    state.mailOtherStateName = mailOtherStateName
  },
  UPDATE_MAIL_COUNTRY_NAME(state, mailCountryName) {
    state.mailCountryName = mailCountryName
  },
  UPDATE_PERSONAL_ADDRESS(state, personalAddressId) {
    state.personalAddressId = personalAddressId
  },
  UPDATE_PERSONAL_ADDRESS1(state, personalAddress1) {
    state.personalAddress1 = personalAddress1
  },
  UPDATE_PERSONAL_ADDRESS2(state, personalAddress2) {
    state.personalAddress2 = personalAddress2
  },
  UPDATE_PERSONAL_ADDRESS3(state, personalAddress3) {
    state.personalAddress3 = personalAddress3
  },
  UPDATE_PERSONAL_POSTCODE(state, personalPostcode) {
    state.personalPostcode = personalPostcode
  },
  UPDATE_PERSONAL_CITY_ID(state, personalCityId) {
    state.personalCityId = personalCityId
  },
  UPDATE_PERSONAL_STATE_ID(state, personalStateId) {
    state.personalStateId = personalStateId
  },
  UPDATE_PERSONAL_COUNTRY_ID(state, personalCountryId) {
    state.personalCountryId = personalCountryId
  },
  UPDATE_PERSONAL_CITY_NAME(state, personalCityName) {
    state.personalCityName = personalCityName
  },
  UPDATE_PERSONAL_STATE_NAME(state, personalStateName) {
    state.personalStateName = personalStateName
  },
  UPDATE_PERSONAL_OTHER_STATE_NAME(state, personalOtherStateName) {
    state.personalOtherStateName = personalOtherStateName
  },
  UPDATE_PERSONAL_COUNTRY_NAME(state, personalCountryName) {
    state.personalCountryName = personalCountryName
  },
  UPDATE_RELATIONSHIP(state, relationshipId) {
    state.relationshipId = relationshipId
  },
  UPDATE_RELATIONSHIPV4(state, relationshipIdV4) {
    state.relationshipIdV4 = relationshipIdV4
  },
}

// actions
const actions = {
  updateFormCompleted({
    commit
  }, formCompleted) {
    commit('UPDATE_FORM_COMPLETED', formCompleted)
  },
  updateFirstName({
    commit
  }, firstname) {
    commit('UPDATE_FIRST_NAME', firstname);
  },
  updateIdentityNo({
    commit
  }, identityNo) {
    commit('UPDATE_IDENTITY_NUMBER', identityNo);
  },
  updatePassportNo({
    commit
  }, passportNo) {
    commit('UPDATE_PASSPORT_NUMBER', passportNo);
  },
  updateIdentityNoOther({
    commit
  }, identityNoOther) {
    commit('UPDATE_IDENTITY_NUMBER_OTHER', identityNoOther);
  },
  updateSex({
    commit
  }, sexId) {
    commit('UPDATE_SEX', sexId);
  },
  updateMaritalStatus({
    commit
  }, maritalStatus) {
    commit('UPDATE_MARITAL_STATUS', maritalStatus);
  },
  updateBirthDt({
    commit
  }, birthDt) {
    commit('UPDATE_BIRTH_DT', birthDt);
  },
  updateOtherBirthDt({
    commit
  }, otherBirthDt) {
    commit('UPDATE_OTHER_BIRTH_DT', otherBirthDt);
  },
  updateNationality({
    commit
  }, nationalityId) {
    commit('UPDATE_NATIONALITY', nationalityId);
  },
  updateReligion({
    commit
  }, religionId) {
    commit('UPDATE_RELIGION', religionId);
  },
  updateBirthCountry({
    commit
  }, birthCountryId) {
    commit('UPDATE_BIRTH_COUNTRY', birthCountryId);
  },
  updateBirthState({
    commit
  }, birthStateId) {
    commit('UPDATE_BIRTH_STATE', birthStateId);
  },
  updateOtherBirthStateName({
    commit
  }, birthStateId) {
    commit('UPDATE_OTHER_BIRTH_STATE_NAME', birthStateId);
  },
  updateRace({
    commit
  }, raceId) {
    commit('UPDATE_RACE', raceId);
  },
  updateEthnic({
    commit
  }, ethnicId) {
    commit('UPDATE_ETHNIC', ethnicId);
  },
  updateEthnicFreeText({
    commit
  }, ethnicFreeText) {
    commit('UPDATE_ETHNIC_FREETEXT', ethnicFreeText);
  },
  updateChronicDisease({
    commit
  }, isChronicDisease) {
    commit('UPDATE_CHRONIC_DISEASE', isChronicDisease);
  },
  updateChronicDiseaseDetails({
    commit
  }, chronicDiseaseDetails) {
    commit('UPDATE_CHRONIC_DISEASE_DETAILS', chronicDiseaseDetails);
  },
  updateDisability({
    commit
  }, isDisable) {
    commit('UPDATE_DISABILITY', isDisable);
  },
  updateLiving({
    commit
  }, isLiving) {
    commit('UPDATE_LIVING', isLiving);
  },
  updatePermanentAddress({
    commit
  }, permanentAddressId) {
    commit('UPDATE_PERMANENT_ADDRESS', permanentAddressId);
  },
  updatePermanentAddress1({
    commit
  }, permanentAddress1) {
    commit('UPDATE_PERMANENT_ADDRESS1', permanentAddress1);
  },
  updatePermanentAddress2({
    commit
  }, permanentAddress2) {
    commit('UPDATE_PERMANENT_ADDRESS2', permanentAddress2);
  },
  updatePermanentAddress3({
    commit
  }, permanentAddress3) {
    commit('UPDATE_PERMANENT_ADDRESS3', permanentAddress3);
  },
  updatePermanentPostcode({
    commit
  }, permanentPostcode) {
    commit('UPDATE_PERMANENT_POSTCODE', permanentPostcode);
  },
  updatePermanentCityId({
    commit
  }, permanentCityId) {
    commit('UPDATE_PERMANENT_CITY_ID', permanentCityId);
  },
  updatePermanentStateId({
    commit
  }, permanentStateId) {
    commit('UPDATE_PERMANENT_STATE_ID', permanentStateId);
  },
  updatePermanentCountryId({
    commit
  }, permanentCountryId) {
    commit('UPDATE_PERMANENT_COUNTRY_ID', permanentCountryId);
  },
  updatePermanentCityName({
    commit
  }, permanentCityName) {
    commit('UPDATE_PERMANENT_CITY_NAME', permanentCityName);
  },
  updatePermanentStateName({
    commit
  }, permanentStateName) {
    commit('UPDATE_PERMANENT_STATE_NAME', permanentStateName);
  },
  updatePermanentOtherStateName({
    commit
  }, permanentOtherStateName) {
    commit('UPDATE_PERMANENT_OTHER_STATE_NAME', permanentOtherStateName);
  },
  updatePermanentCountryName({
    commit
  }, permanentCountryName) {
    commit('UPDATE_PERMANENT_COUNTRY_NAME', permanentCountryName);
  },
  updateMailAddress({
    commit
  }, mailAddressId) {
    commit('UPDATE_MAIL_ADDRESS', mailAddressId);
  },
  updateMailAddress1({
    commit
  }, mailAddress1) {
    commit('UPDATE_MAIL_ADDRESS1', mailAddress1);
  },
  updateMailAddress2({
    commit
  }, mailAddress2) {
    commit('UPDATE_MAIL_ADDRESS2', mailAddress2);
  },
  updateMailAddress3({
    commit
  }, mailAddress3) {
    commit('UPDATE_MAIL_ADDRESS3', mailAddress3);
  },
  updateMailPostcode({
    commit
  }, mailPostcode) {
    commit('UPDATE_MAIL_POSTCODE', mailPostcode);
  },
  updateMailCityId({
    commit
  }, mailCityId) {
    commit('UPDATE_MAIL_CITY_ID', mailCityId);
  },
  updateMailStateId({
    commit
  }, mailStateId) {
    commit('UPDATE_MAIL_STATE_ID', mailStateId);
  },
  updateMailCountryId({
    commit
  }, mailCountryId) {
    commit('UPDATE_MAIL_COUNTRY_ID', mailCountryId);
  },
  updateMailCityName({
    commit
  }, mailCityName) {
    commit('UPDATE_MAIL_CITY_NAME', mailCityName);
  },
  updateMailStateName({
    commit
  }, mailStateName) {
    commit('UPDATE_MAIL_STATE_NAME', mailStateName);
  },
  updateMailOtherStateName({
    commit
  }, mailOtherStateName) {
    commit('UPDATE_MAIL_OTHER_STATE_NAME', mailOtherStateName);
  },
  updateMailCountryName({
    commit
  }, mailCountryName) {
    commit('UPDATE_MAIL_COUNTRY_NAME', mailCountryName);
  },
  updatePersonalAddress({
    commit
  }, personalAddressId) {
    commit('UPDATE_PERSONAL_ADDRESS', personalAddressId);
  },
  updatePersonalAddress1({
    commit
  }, personalAddress1) {
    commit('UPDATE_PERSONAL_ADDRESS1', personalAddress1);
  },
  updatePersonalAddress2({
    commit
  }, personalAddress2) {
    commit('UPDATE_PERSONAL_ADDRESS2', personalAddress2);
  },
  updatePersonalAddress3({
    commit
  }, personalAddress3) {
    commit('UPDATE_PERSONAL_ADDRESS3', personalAddress3);
  },
  updatePersonalPostcode({
    commit
  }, personalPostcode) {
    commit('UPDATE_PERSONAL_POSTCODE', personalPostcode);
  },
  updatePersonalCityId({
    commit
  }, personalCityId) {
    commit('UPDATE_PERSONAL_CITY_ID', personalCityId);
  },
  updatePersonalStateId({
    commit
  }, personalStateId) {
    commit('UPDATE_PERSONAL_STATE_ID', personalStateId);
  },
  updatePersonalCountryId({
    commit
  }, personalCountryId) {
    commit('UPDATE_PERSONAL_COUNTRY_ID', personalCountryId);
  },
  updatePersonalCityName({
    commit
  }, personalCityName) {
    commit('UPDATE_PERSONAL_CITY_NAME', personalCityName);
  },
  updatePersonalStateName({
    commit
  }, personalStateName) {
    commit('UPDATE_PERSONAL_STATE_NAME', personalStateName);
  },
  updatePersonalOtherStateName({
    commit
  }, personalOtherStateName) {
    commit('UPDATE_PERSONAL_OTHER_STATE_NAME', personalOtherStateName);
  },
  updatePersonalCountryName({
    commit
  }, personalCountryName) {
    commit('UPDATE_PERSONAL_COUNTRY_NAME', personalCountryName);
  },
  updateRelationship({
    commit
  }, relationshipId) {
    commit('UPDATE_RELATIONSHIP', relationshipId);
  },
  updateRelationshipV4({
    commit
  }, relationshipIdV4) {
    commit('UPDATE_RELATIONSHIPV4', relationshipIdV4);
  },
}

// getters
const getters = {
  FormCompleted: state => {
    return state.formCompleted
  },
  FirstName: state => {
    return state.firstname
  },
  LastName: state => {
    return state.lastname
  },
  Title: state => {
    return state.title
  },
  IdentityNo: state => {
    return state.identityNo
  },
  PassportNo: state => {
    return state.passportNo
  },
  IdentityNoOther: state => {
    return state.identityNoOther
  },
  Sex: state => {
    return state.sexId
  },
  MaritalStatus: state => {
    return state.maritalStatus
  },
  BirthDt: state => {
    return state.birthDt
  },
  OtherBirthDt: state => {
    return state.otherBirthDt
  },
  Nationality: state => {
    return state.nationalityId
  },
  Religion: state => {
    return state.religionId
  },
  BirthCountry: state => {
    return state.birthCountryId
  },
  BirthState: state => {
    return state.birthStateId
  },
  OtherBirthStateName: state => {
    return state.otherBirthStateName
  },
  Race: state => {
    return state.raceId
  },
  Ethnic: state => {
    return state.ethnicId
  },
  EthnicFreeText: state => {
    return state.ethnicFreeText
  },
  ChronicDisease: state => {
    return state.isChronicDisease
  },
  ChronicDiseaseDetails: state => {
    return state.chronicDiseaseDetails
  },
  Disablity: state => {
    return state.isDisable
  },
  Living: state => {
    return state.isLiving
  },
  PermanentAddress: state => {
    return state.permanentAddressId
  },
  PermanentAddress1: state => {
    return state.permanentAddress1
  },
  PermanentAddress2: state => {
    return state.permanentAddress2
  },
  PermanentAddress3: state => {
    return state.permanentAddress3
  },
  PermanentPostcode: state => {
    return state.permanentPostcode
  },
  PermanentCityId: state => {
    return state.permanentCityId
  },
  PermanentStateId: state => {
    return state.permanentStateId
  },
  PermanentCountryId: state => {
    return state.permanentCountryId
  },
  PermanentCityName: state => {
    return state.permanentCityName
  },
  PermanentStateName: state => {
    return state.permanentStateName
  },
  PermanentOtherStateName: state => {
    return state.permanentOtherStateName
  },
  PermanentCountryName: state => {
    return state.permanentCountryName
  },
  MailAddress: state => {
    return state.mailAddressId
  },
  MailAddress1: state => {
    return state.mailAddress1
  },
  MailAddress2: state => {
    return state.mailAddress2
  },
  MailAddress3: state => {
    return state.mailAddress3
  },
  MailPostcode: state => {
    return state.mailPostcode
  },
  MailCityId: state => {
    return state.mailtCityId
  },
  MailStateId: state => {
    return state.mailStateId
  },
  MailCountryId: state => {
    return state.mailCountryId
  },
  MailCityName: state => {
    return state.mailCityName
  },
  MailStateName: state => {
    return state.mailStateName
  },
  MailOtherStateName: state => {
    return state.mailOtherStateName
  },
  MailCountryName: state => {
    return state.mailCountryName
  },
  PersonalAddress: state => {
    return state.personalAddressId
  },
  PersonalAddress1: state => {
    return state.personalAddress1
  },
  PersonalAddress2: state => {
    return state.personalAddress2
  },
  PersonalAddress3: state => {
    return state.personalAddress3
  },
  PersonalPostcode: state => {
    return state.personalPostcode
  },
  PersonalCityId: state => {
    return state.personalCityId
  },
  PersonalStateId: state => {
    return state.personalStateId
  },
  PersonalCountryId: state => {
    return state.personalCountryId
  },
  PersonalCityName: state => {
    return state.personalCityName
  },
  PersonalStateName: state => {
    return state.personalStateName
  },
  PersonalOtherStateName: state => {
    return state.personalOtherStateName
  },
  PersonalCountryName: state => {
    return state.personalCountryName
  },
  Relationship: state => {
    return state.relationshipId
  },
  RelationshipV4: state => {
    return state.relationshipIdV4
  },
}

export default {
  namespaced: true,
  state() {
    return {
      formCompleted: true,
      id: 0,
      firstname: "",
      lastname: "",
      title: "",
      identityNo: "",
      passportNo: "",
      identityNoOther: "",
      sexId: 0,
      sex: "",
      maritalStatus: 0,
      nationalityId: 0,
      religionId: 0,
      religion: "",
      birthCountryId: 0,
      birthCountry: "",
      birthStateId: 0,
      otherBirthStateName: "",
      birthDt: 0,
      otherBirthDt: 0,
      raceId: 0,
      ethnicId: 0,
      ethnicFreeText: "",
      isChronicDisease: 0,
      chronicDiseaseDetails: "",
      isDisable: 0,
      isLiving: 0,
      relationshipId: 0,
      personalAddressId: 0,
      relationshipIdV4: 0,
    }
  },
  getters,
  actions,
  mutations
}
